import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';


// __________  KPI  __________
export const getLeaveKPIData = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month !== undefined && month !== null) {
      params.append('month', month);
    }
    console.log('Fetching KPI data with params:', { year, month, office });
    const response = await api.get(`${API_URL}/leaves/kpi/dashboard`, {
      params, // This ensures proper encoding
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching KPI dashboard data:', error);
    throw new Error(
      error.response?.data?.message || 'Failed to fetch absence KPI data'
    );
  }
};

/** ─────────── Pending Requests ─────────── **/



/** ─────────── Urgents Requests ─────────── **/

// GET pending leave requests older than 15 days
export const getPendingRequestsOlderThan15Days = async () => {
  const response = await api.get(`${API_URL}/leaves/pending/older-than-15-days`);
  return response.data;
};

// GET pending leaves that are starting tomorrow
export const getPendingRequestsStartingTomorrow = async () => {
  const response = await api.get(`${API_URL}/leaves/pending-starting-tomorrow`);
  return response.data;
};

// GET pending leaves that are starting next week
export const getPendingRequestsStartingNextWeek = async () => {
  const response = await api.get(`${API_URL}/leaves/pending-starting-next-week`);
  return response.data;
};

/** ─────────── Unpaid Leaves Justification ─────────── **/

// POST justification for unpaid leave By HR
export const addLeaveJustificationByHR = async (id, file) => {
  const formData = new FormData();
  if (file) {
    formData.append('file', file);
  }
  
  const response = await api.post(`${API_URL}/leaves/${id}/justifyByHR`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// POST justification for unpaid leave By Employee
export const addLeaveJustification = async (id, file) => {
  const formData = new FormData();
  if (file) {
    formData.append('file', file);
  }
  
  const response = await api.post(`${API_URL}/leaves/${id}/justify`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/** ─────────── Counts & Stats ─────────── **/

// GET count of leave requests by status (filtered)
export const getLeaveRequestsCountByStatusFiltered = async (status, year, month, office) => {
  const params = new URLSearchParams({ status });
  if (year) params.append('year', year);
  if (month) params.append('month', month);
  if (office) params.append('office', office);
  const response = await api.get(`${API_URL}/leaves/status-count-filtered?${params.toString()}`);
  return response.data;
};

export const getLeaveCountByTypeFiltered = async (year, month, office) => {
  const params = new URLSearchParams({ year, office });
  if (month) params.append('month', month);
  const response = await api.get(`${API_URL}/leaves/summary/count-by-type-filtered?${params.toString()}`);
  return response.data;
};

export const getLatestLeavesFiltered = async (year, month, office) => {
  const params = new URLSearchParams({ year, office });
  if (month) params.append('month', month);
  const response = await api.get(`${API_URL}/leaves/latest-filtered?${params.toString()}`);
  return response.data;
};

export const getLeavesByDepartmentFiltered = async (year, month, office) => {
  const params = new URLSearchParams({ year, office });
  if (month) params.append('month', month);
  const response = await api.get(`${API_URL}/leaves/by-department-filtered?${params.toString()}`);
  return response.data;
};

export const getLeaveSummaryByEmployeeAndTypeFiltered = async (year, month, office) => {
  const params = new URLSearchParams({ year, office });
  if (month) params.append('month', month);
  const response = await api.get(`${API_URL}/leaves/summary/by-employee-and-type-filtered?${params.toString()}`);
  return response.data;
};

// GET number of employees on leave for a specific date
export const getEmployeesOnLeaveCount = async (date) => {
  const response = await api.get(`${API_URL}/leaves/on-leave-summary/day`, {
    params: { date }
  });
  return response.data;
};

// GET total count of all leave requests
export const getAllLeaveRequestsCount = async () => {
  const response = await api.get(`${API_URL}/leaves/total-count`);
  return response.data;
};

// GET count of leave requests by status and month
export const getLeaveCountsByStatusAndMonth = async (yearMonth) => {
  const response = await api.get(`${API_URL}/leaves/status-counts-by-month`, {
    params: { yearMonth }
  });
  return response.data;
};

// GET count of leave requests by status
export const getLeaveRequestsCountByStatus = async (status) => {
  const response = await api.get(`${API_URL}/leaves/status-count`, {
    params: { status }
  });
  return response.data;
};

// GET My leaves
export const getMyLeaves = async () => {
  const response = await api.get(`${API_URL}/leaves/my-leaves`);
  return response.data;
};

// GET all leaves (HR)
export const getAllLeaves = async () => {
  const response = await api.get(`${API_URL}/leaves/all`);
  return response.data;
};

// GET leave by ID (HR)
export const getLeaveById = async (id) => {
  const response = await api.get(`${API_URL}/leaves/${id}`);
  return response.data;
};

export const getAllNonDoubledLeaves = async () => {
  const response = await api.get(`${API_URL}/leaves/all/non-doubled`);
  return response.data;
};

export const vacationPlanningData = async (start, end) => {
  const response = await api.get(`${API_URL}/leaves/non-doubled`, {
    params: { start, end }
  });
  return response.data;
};

// GET sick leaves (HR)--> Not approved
export const getSickPendingLeaves = async () => {
  const response = await api.get(`${API_URL}/leaves/pending/sick`);
  return response.data;
};

// GET approved leaves (HR)
export const getApprovedLeaves = async () => {
  const response = await api.get(`${API_URL}/leaves/approved`);
  return response.data;
};

// GET leaves per department (HR)
export const getLeavesPerDepartment = async () => {
  const response = await api.get(`${API_URL}/leaves/leaves_per_department_stats`);
  return response.data;
};

// GET all leave requests for a specific department by name
export const getLeavesByDepartmentName = async (departmentName) => {
  const response = await api.get(`${API_URL}/leaves/by-department`, {
    params: { departmentName }
  });
  return response.data;
};

// POST new leave
export const createLeave = async (formData) => {
  const response = await api.post(`${API_URL}/leaves/submit`, formData);
  return response.data;
};

// POST new leave
export const createLeaveById = async (formData) => {
  const response = await api.post(`${API_URL}/leaves/submit-with-id`, formData);
  return response.data;
};

// DELETE leave
export const deleteLeave = async (id) => {
  const response = await api.delete(`${API_URL}/leaves/${id}`);
  return response.data;
};

// Approve leave
export const approveLeave = async (id) => {
  const response = await api.put(
    `${API_URL}/leaves/approve/${id}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};

export const rejectLeave = async (id, data) => {
  const response = await api.put(`${API_URL}/leaves/reject/${id}`, { reason: data.reason });
  return response.data;
};

// PUT cancel leave
export const cancelLeave = async (id) => {
  const response = await api.put(`${API_URL}/leaves/cancel/${id}`);
  return response.data;
};

// GET leave statistics for a specific employee for current year
export const getEmployeeLeaveStats = async (employeeId) => {
  const response = await api.get(`${API_URL}/leaves/employee/${employeeId}/stats`);
  return response.data;
};

export const getEmployeeDetailedLeaveStats = async (employeeId) => {
  const response = await api.get(`${API_URL}/leaves/employee/${employeeId}/stats`);
  return response.data;
};

// GET leaves for a specific employee by ID
export const getEmployeeLeaves = async (employeeId) => {
  const response = await api.get(`${API_URL}/leaves/employee/${employeeId}/stats`);
  return response.data;
};

// GET leave statistics for a specific employee for current year
export const getEmployeeLeaveStatsByYear = async (employeeId) => {
  const response = await api.get(`${API_URL}/leaves/employee/${employeeId}/stats/year`);
  return response.data;
};

// GET detailed leave statistics for a specific employee
export const getEmployeeDetailedStats = async (employeeId) => {
  const response = await api.get(`${API_URL}/leaves/employee/${employeeId}/detailed-stats`);
  return response.data;
};

 
// GET number of employees on leave for a specific date
export const getEmployeesOnLeaveWeeklyCount = async (date) => {
  const response = await api.get(`${API_URL}/leaves/on-leave-summary/week`, {
    params: { date }
  });
  return response.data;
};

/** ─────────── Balances ─────────── **/

// GET leave balance
export const getLeaveBalance = async () => {
  try {
    const response = await api.get(`${API_URL}/leaves/balance`);
    return response.data;
  } catch (error) {
    console.error('Error fetching leave balance:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers,
      config: error.config
    });
    throw error;
  }
};

// GET leave balance
export const getEmployeeLeaveBalance = async (id) => {
  const response = await api.get(`${API_URL}/leaves/balance/${id}`);
  return response.data;
};

/** ─────────── Holiday Correction ─────────── **/

export const runHolidayCorrection = async (holidayDates, correctLeaves = true, correctAbsences = true) => {
  const response = await api.post(`${API_URL}/leaves/holiday-correction`, {
    holidayDates,
    correctLeaves,
    correctAbsences
  });
  return response.data;
};


